module.exports = __webpack_public_path__ + "dce2574185939a46486fac14a205d735.svg";